import React, { useContext, useState } from 'react';
import _ from 'lodash';

import { FetchContext, HttpMethods } from './FetchContext';
import { AuthContext } from './AuthContext';
import { useAggregatedState } from '../../helpers';

const compileRoute = (route, params) => {
    if (params) {
        const props = Object.getOwnPropertyNames(params);
        if (props && props.length > 0) {
            route = `${route}?`
            props.filter(x => params[x] !== null && params[x] !== undefined).forEach(prop => route = `${route}${prop}=${params[prop]}&`);
            route = route.substr(0, route.length - 1);
        }
    }
    return route;
}

export const ApiRoutes = {
    Auth: {
        Token: () => "/api/Auth/Token",
    },
    User: {
        Me: {
            GetMe: (params) => compileRoute("/api/User/Me", params),
        }
    },
    Bookings: {
        GetBookingsUrl: (params) => compileRoute("/api/Bookings/GetBookingsUrl", params),
    }
}

export const RestApiContext = React.createContext(null);

const { Provider } = RestApiContext;
export const RestApiProvider = ({ ...props }) => {
    const { fetchAuthorized } = useContext(FetchContext);
    const [state, setState] = useAggregatedState({
    });

    const {
        setToken
    } = useContext(AuthContext);

    const sleep = (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    const loginAsync = async ({ email, fiscalCode, bookingCode }) => {
        const r = await fetchAuthorized(ApiRoutes.Auth.Token(), {
            method: HttpMethods.POST,
            body: JSON.stringify({ email, fiscalCode, bookingCode }),
            collectErrorDetails: true
        });
        const accessToken = await r.json();
        setToken(accessToken);
        return accessToken;
    }

    const getMeAsync = async (email) => {
        const r = await fetchAuthorized(ApiRoutes.User.Me.GetMe({ email }), {
            method: HttpMethods.GET
        });
        const user = await r.json();
        return user;
    }

    return (
        <Provider value={{
            loginAsync,
            getMeAsync,
        }}>
            {props.children}
        </Provider>
    );
}